module.exports = __webpack_public_path__ + "static/media/107.1cdad12c.jpg";